import API from 'helpers/API';

import {
  SHIPMENT_FILTERS_FETCH,
  SHIPMENT_FILTERS_SUCCESS,
} from './types';

function getShipmentFilters() {
  return (dispatch) => {
    dispatch({ type: SHIPMENT_FILTERS_FETCH });

    return API.getShipmentFilters().then((response) => {
      const groups = response.shipment_filters;
      dispatch({ type: SHIPMENT_FILTERS_SUCCESS, groups });
      return Promise.resolve(groups);
    });
  };
}

function buildTimeOfDayWindow(shipmentFilter) {
  return shipmentFilter.smartFilterTimeWindowEarlyHour ? {
    time_zone: shipmentFilter.smartFilterTimeWindowTimezone,
    earliest_send_time_hour: shipmentFilter.smartFilterTimeWindowEarlyHour,
    latest_send_time_hour: shipmentFilter.smartFilterTimeWindowLateHour,
  } : null;
}

function buildSmartFilterConfigRequest(shipmentFilter, shipmentFilterId) {
  return {
    smart_filter_configuration_item: {
      shipment_filter_id: shipmentFilterId,
      time_of_day_window: buildTimeOfDayWindow(shipmentFilter),
      priority: shipmentFilter.smartFilterPriority,
      wait_type: shipmentFilter.smartFilterWaitType,
      wait_time_minutes: shipmentFilter.smartFilterWaitTimeMinutes,
    },
  };
}

async function updateSmartFilterConfigItem(shipmentFilter, shipmentFilterId) {
  if (shipmentFilter.smartFilterWaitType || shipmentFilter.smartFilterTimeWindowEarlyHour) {
    const request = buildSmartFilterConfigRequest(shipmentFilter, shipmentFilterId);
    await API.updateSmartFilterConfigurationItem(request);
  } else {
    await API.deleteSmartFilterConfigurationItem(shipmentFilterId);
  }
}

async function createSmartFilterConfigItem(shipmentFilter, shipmentFilterId) {
  if (shipmentFilter.smartFilterWaitType || shipmentFilter.smartFilterTimeWindowEarlyHour) {
    const request = buildSmartFilterConfigRequest(shipmentFilter, shipmentFilterId);
    await API.createSmartFilterConfigurationItem(request);
  }
}

function buildShipmentFilterExpiryRequest(shipmentFilterId, shipmentFilter) {
  return { shipment_filter_id: shipmentFilterId, expires_after_minutes: shipmentFilter.shipmentFilterExpiryMinutes };
}

async function updateShipmentFilterExpiry(shipmentFilter, shipmentFilterId) {
  if (shipmentFilter.shipmentFilterExpiryMinutes) {
    await API.updateShipmentFilterExpiry(buildShipmentFilterExpiryRequest(shipmentFilterId, shipmentFilter));
  } else {
    await API.deleteShipmentFilterExpiry(shipmentFilterId);
  }
}

async function createShipmentFilterExpiry(shipmentFilter, shipmentFilterId) {
  if (shipmentFilter.shipmentFilterExpiryMinutes) {
    await API.createShipmentFilterExpiry(buildShipmentFilterExpiryRequest(shipmentFilterId, shipmentFilter));
  }
}

export function updateShipmentFilter(id, shipmentFilter, smartFilterConfigurationExists, shipmentFilterExpiryExists) {
  return dispatch => API.updateShipmentFilter(id, shipmentFilter)
    .then((response) => {
      dispatch(() => {
        // If there isn't a smart filter config then trying to update an item on it will fail
        // creating one works though because the create endpoint will create a config for the
        // the item to go in if there isn't one.
        if (smartFilterConfigurationExists) {
          updateSmartFilterConfigItem(shipmentFilter, response.shipment_filter.id);
        } else {
          createSmartFilterConfigItem(shipmentFilter, shipmentFilter.id);
        }

        if (shipmentFilterExpiryExists) {
          updateShipmentFilterExpiry(shipmentFilter, response.shipment_filter.id);
        } else {
          createShipmentFilterExpiry(shipmentFilter, response.shipment_filter.id);
        }

        getShipmentFilters();
      });
    });
}

export function createShipmentFilter(shipmentFilter) {
  return dispatch => API.createShipmentFilter(shipmentFilter)
    .then((response) => {
      dispatch(() => {
        getShipmentFilters();
        createSmartFilterConfigItem(shipmentFilter, response.shipment_filter.id);
        createShipmentFilterExpiry(shipmentFilter, response.shipment_filter.id);
      });
      return Promise.resolve(response);
    });
}

export function deleteShipmentFilter(id) {
  return dispatch => API.deleteShipmentFilter(id)
    .then(() => {
      dispatch(() => {
        getShipmentFilters();
        API.deleteSmartFilterConfigurationItem({ shipment_filter_id: id });
        API.deleteShipmentFilterExpiry({ shipment_filter_id: id });
      });
    });
}
